"use client";

import { Heading, Text } from "@pamperedchef/design-system";

import {
	ListingAppliedFilters,
	ListingFilters,
	ListingSort,
	useListingTotal
} from "../../listing-state";

import * as styles from "./ResultsToolbar.module.scss";

export interface ResultsToolbarProps {
	showCount: boolean;
	heading?: string;
}

function countLabel(total: number): string {
	return `${total} ${total === 1 ? "item" : "items"}`;
}

export function ResultsToolbar({
	showCount,
	heading
}: ResultsToolbarProps): JSX.Element {
	const total = useListingTotal();

	return (
		<div className={styles["toolbar"]} data-component="ResultsToolbar">
			{heading ? (
				<Heading tag="h2" className={styles["toolbar__heading"]}>
					{heading}
				</Heading>
			) : null}
			<div className={styles["toolbar__row"]}>
				{showCount ? (
					<Text
						tag="p"
						className={styles["toolbar__count"]}
						aria-live="polite"
					>
						{countLabel(total)}
					</Text>
				) : null}
				<div className={styles["toolbar__drawer"]}>
					<ListingFilters presentation="drawer" />
				</div>
				<div className={styles["toolbar__sort"]}>
					<ListingSort />
				</div>
			</div>
			<ListingAppliedFilters />
		</div>
	);
}
